/* eslint-disable  */
import React, { useState,useEffect} from "react";
import { TextField, Button, Container, Stack,SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Box from '@mui/material/Box';
import {get}  from '../library/Api';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import {post} from '../library/Api';
import { useLocation } from "react-router-dom";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { buildVehiclePayload } from '../helpers/vehicleHelpers';
import PulseLoader from "react-spinners/PulseLoader";

const VehicleForm = ({vehicle_form_data,update_visibility}) => {
  console.log("veicle page ");

  const[customerId,setCustomerId] = useState('')
  const [Name, setFirstName] = useState("");
  const [company, setCompany] = useState("");
  const [noOfVehicle,setNoOfVehicle] = useState("0");

  const [carname, setCarname] = useState("");
  const [plate, setplate] = useState("");
  const [color, setColor] = useState("");
  const [state, setState] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  
  const[hideCancel,setHideCancel] = useState(false);
  const[addCount,setAddCount] = useState(0);
  const[open,setOpen] = useState(false)
  const [userList, setDatas] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const navigate = useNavigate();
  const [admin_id, setadmin_id] = useState('');
  // const lcompany = localStorage.getItem("company");

  const location = useLocation();
  const passed_data = location.state || vehicle_form_data;
  // console.log("kjklj",lcompany)
  // console.log("----------yes--->",passed_data.name);
  const states = [
    { label: 'Alabama (AL)', value: 'Alabama', short_name: 'AL' },
    { label: 'ALASKA (AK)', value: 'New York', short_name: 'AK' },
    { label: 'AMERICAN SAMOA (AS)', value: 'AMERICAN SAMOA', short_name: 'AS' },
    { label: 'ARIZONA (AZ)', value: 'ARIZONA', short_name: 'AZ' },
    { label: 'ARKANSAS (AR)', value: 'ARKANSAS', short_name: 'AR' },
    { label: 'CALIFORNIA (CA)', value: 'CALIFORNIA', short_name: 'CA' },
    { label: 'COLORADO (CO)', value: 'COLORADO', short_name: 'CO' },
    { label: 'CONNECTICUT (CT)', value: 'CONNECTICUT', short_name: 'CT' },
    { label: 'DELAWARE (DE)', value: 'DELAWARE', short_name: 'DE' },
    { label: 'DISTRICT OF COLUMBIA (DC)', value: 'DISTRICT OF COLUMBIA', short_name: 'DC' },
    { label: 'FLORIDA (FL)', value: 'FLORIDA', short_name: 'FL' },
    { label: 'GEORGIA (GA)', value: 'GEORGIA', short_name: 'GA' },
    { label: 'GUAM (GU)', value: 'GUAM', short_name: 'GU' },
    { label: 'HAWAII (HI)', value: 'HAWAII', short_name: 'HI' },
    { label: 'IDAHO (ID)', value: 'IDAHO', short_name: 'ID' },
    { label: 'ILLINOIS (IL)', value: 'ILLINOIS', short_name: 'IL' },
    { label: 'INDIANA (IN)', value: 'INDIANA', short_name: 'IN' },
    { label: 'IOWA (IA)', value: 'IOWA', short_name: 'IA' },
    { label: 'KANSAS (KS)', value: 'KANSAS', short_name: 'KS' },
    { label: 'KENTUCKY (KY)', value: 'KENTUCKY', short_name: 'KY' },
    { label: 'LOUISIANA (LA)', value: 'LOUISIANA', short_name: 'LA' },
    { label: 'MAINE (ME)', value: 'MAINE', short_name: 'ME' },
    { label: 'MARYLAND (MD)', value: 'MARYLAND', short_name: 'MD' },
    { label: 'MASSACHUSETTS (MA)', value: 'MASSACHUSETTS', short_name: 'MA' },
    { label: 'MICHIGAN (MI)', value: 'MICHIGAN', short_name: 'MI' },
    { label: 'MINNESOTA (MN)', value: 'MINNESOTA', short_name: 'MN' },
    { label: 'MISSISSIPPI (MS)', value: 'MISSISSIPPI', short_name: 'MS' },
    { label: 'MISSOURI (MO)', value: 'MISSOURI', short_name: 'MO' },
    { label: 'MONTANA (MT)', value: 'MONTANA', short_name: 'MT' },
    { label: 'NEBRASKA (NE)', value: 'NEBRASKA', short_name: 'NE' },
    { label: 'NEVADA (NV)', value: 'NEVADA', short_name: 'NV' },
    { label: 'NEW HAMPSHIRE (NH)', value: 'NEW HAMPSHIRE', short_name: 'NH' },
    { label: 'NEW JERSEY (NJ)', value: 'NEW JERSEY', short_name: 'NJ' },
    { label: 'NEW MEXICO (NM)', value: 'NEW MEXICO', short_name: 'NM' },
    { label: 'NEW YORK (NY)', value: 'NEW YORK', short_name: 'NY' },
    { label: 'NORTH CAROLINA (NC)', value: 'NORTH CAROLINA', short_name: 'NC' },
    { label: 'NORTH DAKOTA (ND)', value: 'NORTH DAKOTA', short_name: 'ND' },
    { label: 'NORTHERN MARIANA IS (MP)', value: 'NORTHERN MARIANA IS', short_name: 'MP' },
    { label: 'OHIO (OH)', value: 'OHIO', short_name: 'OH' },
    { label: 'OKLAHOMA (OK)', value: 'OKLAHOMA', short_name: 'OK' },
    { label: 'OREGON (OR)', value: 'OREGON', short_name: 'OR' },
    { label: 'PENNSYLVANIA (PA)', value: 'PENNSYLVANIA', short_name: 'PA' },
    { label: 'PUERTO RICO (PR)', value: 'PUERTO RICO', short_name: 'PR' },
    { label: 'RHODE ISLAND (RI)', value: 'RHODE ISLAND', short_name: 'RI' },
    { label: 'SOUTH CAROLINA (SC)', value: 'SOUTH CAROLINA', short_name: 'SC' },
    { label: 'SOUTH DAKOTA (SD)', value: 'SOUTH DAKOTA', short_name: 'SD' },
    { label: 'TENNESSEE (TN)', value: 'TENNESSEE', short_name: 'TN' },
    { label: 'TEXAS (TX)', value: 'TEXAS', short_name: 'TX' },
    { label: 'UTAH (UT)', value: 'UTAH', short_name: 'UT' },
    { label: 'VERMONT (VT)', value: 'VERMONT', short_name: 'VT' },
    { label: 'VIRGINIA (VA)', value: 'VIRGINIA', short_name: 'VA' },
    { label: 'VIRGIN ISLANDS (VI)', value: 'VIRGIN ISLANDS', short_name: 'VI' },
    { label: 'WASHINGTON (WA)', value: 'WASHINGTON', short_name: 'WA' },
    { label: 'WEST VIRGINIA (WV)', value: 'WEST VIRGINIA', short_name: 'WV' },
    { label: 'WISCONSIN (WI)', value: 'WISCONSIN', short_name: 'WI' },
    { label: 'WYOMING (WY)', value: 'WYOMING', short_name: 'WY' },
  ];
  const alt_states = [{  label: 'Alabama (AL)',  value: 'Alabama'},{  label: 'ALASKA (AK)',   value: 'New York' }, {  label: 'AMERICAN SAMOA (AS)',  value: 'AMERICAN SAMOA'
    }, {   label: 'ARIZONA (AZ)',   value: 'ARIZONA' }, {   label:'ARKANSAS (AR)',   value:'ARKANSAS' },{ label:'CALIFORNIA (CA)', value:'CALIFORNIA'},{label:'COLORADO (CO)', value:'COLORADO' },{ label:'CONNECTICUT (CT)',  value:'CONNECTICUT'},
     { label:' DELAWARE (DE)', value:' DELAWARE' },{   label:'DISTRICT OF COLUMBIA (DC)', value:'DISTRICT OF COLUMBIA' },  {   label:'FLORIDA (FL)',   value:'FLORIDA' }, { label:'GEORGIA (GA)',   value:'GEORGIA'
    }, { label:'GUAM (GU)', value:'GUAM'},{ label:'HAWAII (HI)', value:'HAWAII' }, {   label:'IDAHO (ID)', value:'IDAHO' },{label:'ILLINOIS (IL)',value:'ILLINOIS'}, {  label:'INDIANA (IN)',  value:'INDIANA'},{  label:'IOWA (IA)', value:'IOWA'},
    { label:'KANSAS (KS)', value:'KANSAS'},{ label:'KENTUCKY (KY)', value:'KENTUCKY'},{  label:'LOUISIANA (LA)',  value:'LOUISIANA'},
    { label:'MAINE (ME)', value:'MAINE'},{  label:'MARYLAND (MD)',  value:'MARYLAND' }, {   label:'MASSACHUSETTS (MA)',   value:'MASSACHUSETTS' }, {  label:'MICHIGAN (MI)',value:'MICHIGAN' }, 
    {  label:'MINNESOTA (MN)',  value:'MINNESOTA' }, {  label:'MISSISSIPPI (MS)',  value:'MISSISSIPPI'},{  label:' MISSOURI (MO)',  value:' MISSOURI' },
    { label:'MONTANA (MT)',  value:'MONTANA 	MT' }, { label:'NEBRASKA (NE)', value:'NEBRASKA'},{ label:'NEVADA (NV)',  value:'NEVADA'}, { label:'NEW HAMPSHIRE (NH)', value:'NEW HAMPSHIRE'
    }, { label:'NEW JERSEY (NJ)', value:'NEW JERSEY'},  {label:'NEW MEXICO (NM)', value:'NEW MEXICO' }, { label:'NEW YORK (NY)', value:'NEW YORK'},{ label:'NORTH CAROLINA (NC)',  value:'NORTH CAROLINA'
    }, {  label:'NORTH DAKOTA (ND)',  value:'NORTH DAKOTA 	ND' }, {  label:'NORTHERN MARIANA IS (MP)',  value:'NORTHERN MARIANA IS'},{ label:'OHIO (OH)',      value:'OHIO' },{ label:'OKLAHOMA (OK)',  value:'OKLAHOMA'}, { label:'OREGON (OR)',
      value:'OREGON' }, {label:'PENNSYLVANIA (PA)',  value:'PENNSYLVANIA'}, {  label:'PUERTO RICO (PR)',  value:'PUERTO RICO'}, {  label:'RHODE ISLAND (RI)',  value:'RHODE ISLAND'}, {  label:'SOUTH CAROLINA (SC)',  value:'SOUTH CAROLINA '}, {  label:'SOUTH DAKOTA (SD)',  value:'SOUTH DAKOTA'
    }, { label:'TENNESSEE (TN)',  value:'TENNESSEE'},{  label:'TEXAS (TX)',  value:'TEXAS' },  {   label:'UTAH (UT)',   value:'UTAH'}, {  label:'VERMONT 	(VT)',value:'VERMONT'}, 
    {  label:'VIRGINIA (VA)',  value:'VIRGINIA'},  { label:'VIRGIN ISLANDS (VI)', value:' VIRGIN ISLANDS'},  { label:'WASHINGTON (WA)', value:'WASHINGTON'}, {  label:' WEST VIRGINIA (WV)',   value:' WEST VIRGINIA'}, {     label:' WISCONSIN (WI)',   value:' WISCONSIN' },  {   label:' WYOMING (WY)',   value:' WYOMING' },  ];
  
  
    const name = [{ value: 'Neethu', label: 'Neethu'},{  value: 'Hari',  label: 'Hari'},{  value: 'Karthik',  label: 'Karthik'},{  value: 'Dev',  label: 'Dev'}];
  
   useEffect(() => {
      setCustomerId(passed_data.customer_id);
      setFirstName(passed_data.name);
      setCompany(passed_data.company);
      setNoOfVehicle(passed_data.vehicles);
      setHideCancel(true);

  }, [vehicle_form_data]);


  useEffect(() => {
    var mcdata = JSON.parse(localStorage.getItem("MCData"));
    var tempadmin_id= mcdata.admin_id
    setadmin_id(tempadmin_id)
  }, []);

  const [formData, setFormData] = useState(
    Array.from({ length: passed_data.vehicles},() => ({
      make: '',
      model: '',
      license_plate: '',
      color: '',
      state: 'TX',
    }))
  );
  const [licensePlateSpaceError, setLicensePlateSpaceError] = useState({});
  // useEffect(() => {
  //   setDatas([])
  //   get(`get_customers_by_company_new`,{
  //     params: { company: company }
  //   }).then((res) => {
  //     const data = res;
  //     // console.log(data.data.names);
  //     const new_result = data.data.names
  //     setFirstName("");
  //     setDatas(new_result);
  //     // const usernames = data.data.names
  //   });}, [company]);

  // useEffect(() => {
  //   get(`get_customer_by_selection`,{
  //     params: {
  //       customer_id: passed_data.customer_id
  //     }
  //   }).then((res) => {
  //     // const data = res;
  //     setCustomerList(res.data.customer)
      
  //   });
  // }, []);
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    if (name === "license_plate") {
      const hasWhitespace = /\s/.test(value);
      const normalized = value.replace(/\s+/g, "");
      setLicensePlateSpaceError((prev) => ({ ...prev, [index]: hasWhitespace }));
      setFormData((prevData) => {
        const newData = [...prevData];
        newData[index] = { ...newData[index], [name]: normalized };
        return newData;
      });
      return;
    }
    setFormData((prevData) => {
      const newData = [...prevData];
      newData[index] = { ...newData[index], [name]: value };
      return newData;
    });
    // console.log("------------>>-----<< = ",formData)
  };
  const handleLicensePlateKeyDown = (index, e) => {
    if (e.key === " ") {
      e.preventDefault();
      setLicensePlateSpaceError((prev) => ({ ...prev, [index]: true }));
    }
  };
  const handleCustomerNameChange = (e) =>{
    const new_change = e.target.value
    setFirstName(e.target.value)
  }
  function checkPropertiesPresent(item) {
    return item.color && item.make && item.model && item.license_plate && item.state;
  }
  const handleCancel = () => {
     navigate("/registers");
    // console.log("cancell click")
    // for (let i = 0; i < formData.length; i++) {
    //   console.log(formData[i])
    //   console.log("-------------------------------------")
    // }

      // let error_state = false; // Use 'let' instead of 'const' for the error_state variable
      // formData.forEach((item) => {
      //   if (item.color && item.car_name && item.license_plate && item.state) {
      //     console.log('correct');
      //   } else if (!(item.color || item.car_name || item.license_plate) && item.state) {
      //     console.log('not Error', item);
      //   } else {
      //     console.log('ERROR', item);
      //     error_state = true;
          
          
          

      //     toast.error("Error .. Please provide valid information", {
      //       autoClose: 3000,
      //     });
      //     return;
      //   }
      // });
      // console.log("errro ststte",error_state)
      // // 
      // if (!error_state){

        
      //   const filteredList = formData.filter(checkPropertiesPresent);
      //   // console.log("---result data-------------from --",filteredList)
      //   const data ={
      //     customer_id :customerId,
      //     company:company,
      //     data_list:filteredList

      //   }
      //   console.log("--------------------------------------------------------------------",data)
      //   // post call
      //   post("insert_vehicledata", data)
      //   .then((response) => {
      //     if (response.status === 200) {
      //       toast.success(response.data.message);
      //       setTimeout(() => {
      //           // Code to execute after 2 seconds
      //           console.log('Timer finished!');
      //           const formcount = Number(addCount)+1
      //           setAddCount(formcount)
      //           console.log("addCount = ",addCount)
      //           console.log("no of Vehicle = ",noOfVehicle)
      //           setOpen(false)
      //           if (formcount == Number(noOfVehicle)){
      //             navigate("/registers")
      //           }
      //           // navigate(-1)
      //         }, 2000);
      //     }
      //     else {
      //       toast.error(`Failed to add vehicle`);

      //     }
      //   }, (error) => {
      //     toast.error(error.response.data.message, {
      //       autoClose: 3000,
      //     });
      //   })
      //   // post call 

      // } 
      // update_visibility(false)
      // 
  }


  const handleAdd = () => {
    setOpen(true)
  }


  
  function handleSubmit() {
    // Filter valid items first
    const filteredList = formData.filter(checkPropertiesPresent);
    
    if (filteredList.length === 0) {
      toast.error("Please provide all required fields (Make, Model, Color, License Plate, State)", {
        autoClose: 3000,
      });
      return;
    }
    
    // Use shared helper to build payload
    const { error, payload } = buildVehiclePayload({
      customer_id: customerId,
      company: company,
      admin_id: admin_id,
      vehicles: filteredList
    });
    
    if (error) {
      // Show field-level errors
      const errorMessages = Object.values(error).flatMap(err => Object.values(err));
      toast.error(`Validation failed: ${errorMessages.join(', ')}`, {
        autoClose: 3000,
      });
      return;
    }
    
    // Log payload for verification
    console.log("[Flow 1 - Create Customer] Vehicle payload:", JSON.stringify(payload, null, 2));
    setIsLoading(true);
    // Post call
    post("insert_vehicledata", payload)
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          toast.success(response.data.message);
          const resetList = formData.map(item => ({
            make: '',
            model: '',
            license_plate: '',
            color: '',
            state: 'TX',
          }));
          setFormData(resetList);
          setTimeout(() => {
            console.log('Timer finished!');
            setOpen(false);
            navigate("/register");
          }, 2000);
        } else {
          const resetList = formData.map(item => ({
            make: '',
            model: '',
            license_plate: '',
            color: '',
            state: 'TX',
          }));
          setFormData(resetList);
          toast.error(`Failed to add vehicle`);
        }
      }, (error) => {
        setIsLoading(false);
        const resetList = formData.map(item => ({
          make: '',
          model: '',
          license_plate: '',
          color: '',
          state: 'TX',
        }));
        setFormData(resetList);
        toast.error(error.response?.data?.message || 'Failed to add vehicle', {
          autoClose: 3000,
        });
      });
  }

  

  return (
    <React.Fragment>
      <ToastContainer/>
        <Box sx={{ display: 'flex' }}>
    <Sidebar />
    <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 0 }}>
    {/* className="col-lg-6 m-auto form-style" */}
    <div  >
      <br />
        {/* <h3 className="heading-style mb-4">Add Vehicle Details</h3> */}
       <br />
        <form onSubmit={handleSubmit} action={<Link to="/login" />}>
          { false && !open && (<>
        <div className="text-end">  
          
          <Button
         className="btn-sty"
           onClick={handleAdd}
           startIcon={
             <SvgIcon fontSize="small">
               <PlusIcon />
             </SvgIcon>
           }
           variant="contained"
         >
           Add
         </Button> </div>
         </>)}

         <br /> 
         {false && (<>
         <Stack spacing={3} direction="row" sx={{ marginBottom: 2 }} className="mb-0">  
               <TextField
                  fullWidth
                  disabled
                  label="Customer Name"
                  name="name"
                  onChange={handleCustomerNameChange}
                  required
                  // select
                  value={Name}
                  SelectProps={{ native: true }}
                  InputLabelProps={{ shrink: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                >
                  {/* <option key='' value=''> Please select </option> */}
              {/* {userList.map((customername) => ( <option key={customername} value={customername}>{customername}</option>))} */}
             
                </TextField>

               {/* <TextField
                  fullWidth
                  label="Company"
                  name="name"
                  disabled
                  onChange={(e) => setCompany(e.target.value)}
                  required
                  value={company}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                >
                
                </TextField> */}

          <TextField
              type="text"
              disabled
              variant="outlined"
              color="secondary"
              label="No Of Vehicles"
              // onChange={(e) => setNoOfVehicle(e.target.value)}
              value={noOfVehicle}
              fullWidth
              required
            />
                </Stack>   </>)}
          {/* <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }} className="mb-0">  </Stack> */}
         
          <h3 className="heading-style mb-4">Add Vehicle Details</h3>
          { true&& <>
          <br />
          
          {/* <Stack spacing={4} direction="row" sx={{ marginBottom: 2 }} className="mb-0"> 
          <TextField
              type="text"
              variant="outlined"
              color="secondary"
              label="Car Name"
              onChange={(e) => setCarname(e.target.value)}
              value={carname}
              fullWidth
              required
            />
          
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Licence Plate"
            onChange={(e) => setplate(e.target.value)}
            value={plate}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Color"
            onChange={(e) => setColor(e.target.value)}
            value={color}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
               <TextField
                  fullWidth
                  label="Select State"
                  name="state"
                  onChange={(e) => setState(e.target.value)}
                  required
                  select
                  value={state}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                > 

                <option key = '0'value="">Please select</option>
                  {states.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>  
          
                </Stack> */}
                    

{isLoading ? (
                <div className="table-style" style={{ textAlign: 'center', marginTop: "10%" }}>
                    <PulseLoader
                        color="#02487B"
                        height={29}
                        margin={4}
                        radius={24}
                        width={4}
                    />
                    <p style={{ fontWeight: "bold", color: "#02487B" }}>Please Wait...</p>
                </div>
            ) : (
<>
                      <br />
                      {formData.map((data, index) => (
        <Box key={index} sx={{ mb: 2, p: 1 }}>
           <Stack spacing={4} direction="row" sx={{ marginBottom: 2 }} className="mb-0">
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label={`Make ${index + 1}`}
            name="make"
            required
            value={data.make}
            onChange={(e) => handleChange(index, e)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label={`Model ${index + 1}`}
            name="model"
            required
            value={data.model}
            onChange={(e) => handleChange(index, e)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label={`Colour ${index + 1}`}
            name="color"
            required
            value={data.color}
            onChange={(e) => handleChange(index, e)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label={`License Plate ${index + 1}`}
            name="license_plate"
            required
            value={data.license_plate}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleLicensePlateKeyDown(index, e)}
            error={Boolean(licensePlateSpaceError[index])}
            helperText={
              licensePlateSpaceError[index]
                ? "Spaces are not allowed in License Plate."
                : ""
            }
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label={`Select State ${index + 1}`}
            name="state"
            onChange={(e) => handleChange(index, e)}
            select
            required
            value={data.state}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true }}
            sx={{ mb: 2 }}
          >
            <option key="0" value="">
              Please select
            </option>
            {states.map((option) => (
              <option key={option.value} value={option.short_name}>
                {option.short_name}
              </option>
            ))}
          </TextField>
          
          </Stack>
        </Box>
      ))}
     
           
                   <br /> <br /> <br />
                    <div className="text-end">
          <Button variant="contained" color="primary" onClick={handleSubmit} size="large" className="me-4  btn-sty">
            Create
          </Button>
          
          <Button variant="contained" color="error"  onClick={handleCancel} size="large" className=" btn-sty">Close</Button>
          </div>
          </>
          )}
          {/* <br />  */}
          {hideCancel || !open && (<>
          <div className="text-end">  <Button variant="outlined" color="error"  onClick={handleCancel} size="large" className=" btn-sty">Cancel</Button></div> </>)}
          </>
          }
        </form>
        
        {/* <small>Already have an account? <Link to="/login">Login Here</Link></small> */}
        
        </div>
           
           </Box>
     </Box>
    </React.Fragment>
  );
};

export default VehicleForm;
